import { useContext, useEffect } from 'react'
import { EditorContext } from '../../contexts/Editor.context'
import Editor from './Editor'
import { updateFontCssVars } from '../../utils/font'
import { updateColorCssVars } from '../../utils/colors'
import Loader from '../Loader'
import { Link } from 'react-router'
import { ROUTE } from '../../cnst/router.cnst'
import LinkButton from '../LinkButton'
import { useTr } from '../../utils/useTr'
import { TrKey } from '../../cnst/translations/trKey.cnst'
import { LucideIconName } from '@bm-js/atlascloud-shared'
import { useCustomer } from '../../utils/hooks'

const EditorWrapper = () => {
  const { tr } = useTr()
  const { editorData, status } = useContext(EditorContext)
  const customer = useCustomer()

  useEffect(() => {
    const { workingConfig } = editorData || {}
    if (!workingConfig) return
    updateColorCssVars(workingConfig)
    updateFontCssVars(workingConfig)
  }, [editorData])

  if (status.isLoading || !customer)
    return (
      <div className='flex items-center justify-center h-screen'>
        <Loader />
      </div>
    )

  if (status.isError || !editorData)
    return (
      <div className='items-center justify-center flex-col flex h-screen text-center'>
        <p className='text-primary-400 text-2xl font-bold mb-4'>
          {tr(TrKey.somethingWentWrong)}
        </p>
        <Link to={ROUTE.DASHBOARD}>
          <LinkButton icon={LucideIconName.SquareArrowLeft}>
            {tr(TrKey.editorBackToOverview)}
          </LinkButton>
        </Link>
      </div>
    )

  return <Editor />
}

export default EditorWrapper
